import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { routeService } from '../../../services/routeService'
import { useAuthContext } from '../../../hooks/useAuthContext'

const OverallComments = ({ setLoading, onSubmit, routeTemplateId }) => {
  const { user } = useAuthContext()
  const [comment, setComment] = useState('')
  const [selected, setSelected] = React.useState([])
  const [allRoutes, setAllRoutes] = useState([])
  const [inNextParallel, setNextParallel] = useState(false)

  // fetching parallel routes
  useEffect(() => {
    ;(async () => {
      const res = await routeService.getParallelRoutes(user, routeTemplateId)
      setAllRoutes(res?.routes || [])
      setSelected(res?.routes || [])
      setNextParallel(res?.is_next_parallel || false)
    })()
  }, [routeTemplateId, user])

  return (
    <div>
      <fieldset
        className="preview-comment"
        sx={{ border: '1px solid ##e1d9fb !important' }}
        style={{
          borderRadius: '20px',
          marginBottom: '10px',
        }}
      >
        <legend
          style={{
            height: '32px',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            top: '-16px',
          }}
        >
          <Typography className="textprimaryblue fontWeight700" sx={{ fontSize: '13px' }}>
            Overall comments
          </Typography>
        </legend>

        <Box style={{ margin: '16px 8px' }}>
          <TextField
            placeholder="Enter overall comments"
            onChange={(e) => setComment(e.target.value)}
            variant="outlined"
            multiline
            minRows={5}
            color="primary"
            fullWidth
            value={comment}
            size="small"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                '& fieldset': {
                  display: 'none', // Completely hide the default fieldset
                },
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none !important', // Forcefully remove outline
              },
              '& .MuiInputBase-root': {
                border: '1px solid #e1d9fb !important', // Ensure custom border is
                backgroundColor: '#fff !important',
              },
              '& .MuiOutlinedInput-input': {
                padding: '10px', // Adjust padding to prevent text cut-off
              },
            }}
            InputLabelProps={{
              sx: {
                display: 'none', // Hide the label completely
              },
            }}
          />
          {inNextParallel && (
            <Autocomplete
              multiple
              fullWidth
              options={allRoutes}
              getOptionLabel={(option) => option.route_template_name}
              value={selected}
              onChange={(e, newValue) => setSelected(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Select All Parallel Routes" placeholder="Choose..." />
              )}
              sx={{
                mt: 2,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                },
                '& .MuiInputBase-root': {
                  backgroundColor: '#fff !important',
                },
              }}
            />
          )}

          <Button
            color="primary"
            variant="contained"
            form="data-entry-form"
            type="submit"
            style={{ marginTop: '16px' }}
            onClick={() => {
              onSubmit && onSubmit(comment, selected)
              setLoading && setLoading(true)
            }}
            disabled={inNextParallel && selected.length <= 0}
          >
            Submit
          </Button>
          <br />
          {inNextParallel && selected.length <= 0 ? (
            <Typography variant="p" sx={{ fontSize: '13px', mt: 2, color: 'red' }}>
              Must select at least one route to submit the task.
            </Typography>
          ) : (
            <></>
          )}
        </Box>
      </fieldset>
    </div>
  )
}

export default OverallComments
